module.exports = __webpack_public_path__ + "static/media/cluster-userflow-3.e02a5a28.jpg";